import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=0fbc0ba6&"
import script from "./AppLoader.vue?vue&type=script&lang=js&"
export * from "./AppLoader.vue?vue&type=script&lang=js&"
import style0 from "./AppLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports